// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__23ULt","header":"PatientQuestionnaire_header__3BHT5","info":"PatientQuestionnaire_info__1eEV8"};